import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=a2b3163c&lang=scss"
import "./index.vue?vue&type=style&index=1&id=a2b3163c&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2b3163c"]])

export default __exports__